import { Component, OnInit, ViewChild } from '@angular/core';
import { EmopTableProComponent } from '../../../../components/emop-table-pro/emop-table-pro.component';
import { EmopPublicWorkflowCreateService } from '../../emop-public-workflow-create.service';

@Component({
  selector: 'app-emop-public-workflow-create-new',
  templateUrl: './emop-public-workflow-create-new.component.html',
  styleUrls: ['./emop-public-workflow-create-new.component.scss']
})
export class EmopPublicWorkflowCreateNewComponent implements OnInit {
  template; // 当前模板的信息
  workflowName: string = ''; // 流程名
  remark: string = ''; // 备注
  constructor(
    public EmopPublicWorkflowCreateService: EmopPublicWorkflowCreateService
  ) { }
  ngOnInit(): void {
  }
  templateChange(template) {
    this.template = template;
    this.workflowName = template.name;
    this.EmopPublicWorkflowCreateService.templateChange(template.key);
  }
}
